import React from 'react';
import PropTypes from 'prop-types';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import DepartmentFilterActions from 'actions/DepartmentFilterActions';
import {Map, Set} from 'immutable';
import {DepartmentPrompt} from 'components/dashboard/ManagerDepartmentSelect';
import {DepartmentToggle} from 'components/dashboard/DepartmentToggle';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

export default class AdminDepartmentSelect extends React.PureComponent {
  render() {
    const {selectedDepts: selectedIds, allDepts} = this.props;
    const options = allDepts
      .toList()
      .filter(dept => !selectedIds.has(dept.id))
      .map(dept => ({
        label: dept.name,
        value: dept.id,
      }))
      .sortBy(opt => opt.label)
      .toArray();

    const selectedDepts = selectedIds.map(id => allDepts.get(id)).sortBy(dept => dept.name);

    return (
      <div className="admin-department-select">
        <DepartmentPrompt selectedDepts={selectedDepts} allDepts={allDepts} />
        <FieldContainer label="Departments">
          <Autocomplete
            multiple
            fullWidth
            renderInput={params => (
              <TextField
                {...params}
                placeholder="Start typing department name"
                size="small"
                variant="outlined"
              />
            )}
            options={options}
            onChange={(e, [opt]) => {
              DepartmentFilterActions.toggleDepartment(opt.value);
            }}
            // Dont display the value being selected
            value={[]}
            getOptionLabel={opt => opt.label}
            getOptionSelected={() => false}
          />
        </FieldContainer>
        {!selectedDepts.isEmpty() && (
          <div className="dept-grid">
            {selectedDepts.map(dept => (
              <DepartmentToggle key={dept.id} department={dept} selected />
            ))}
          </div>
        )}
      </div>
    );
  }
}

AdminDepartmentSelect.propTypes = {
  selectedDepts: PropTypes.instanceOf(Set),
  allDepts: PropTypes.instanceOf(Map),
};
